import { ACTION_AUTHEN_REQUEST_OTP, ACTION_AUTHEN_REQUEST_OTP_ERROR, ACTION_AUTHEN_REQUEST_OTP_SUCCESS,  ACTION_AUTHEN_VERIFY_OTP_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}

export const requestOTPReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_AUTHEN_REQUEST_OTP:
            return { ...state, isLoading: true, erro_msg: undefined };
        case ACTION_AUTHEN_REQUEST_OTP_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data };
        case ACTION_AUTHEN_REQUEST_OTP_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };

        case ACTION_AUTHEN_VERIFY_OTP_SUCCESS:
            return { ...state, ...initState }
        default:
            return state;
    }
}